import { useState } from 'react';
import { useSavePosition, errMessage, type Position } from './systemMasters';
import { useNotify } from '../../../components/notifications';
import { useConfirm } from '../../../components/confirm';

/** Compact Position editor opened from the Division ▸ Positions grid / picker Edit pencil. */
export function PositionDetailDialog({ position, onClose }: { position: Position; onClose: () => void }) {
  const notify = useNotify();
  const { alert } = useConfirm();
  const save = useSavePosition();
  const [name, setName] = useState(position.positionName ?? '');
  const [sort, setSort] = useState(position.sort != null ? String(position.sort) : '');
  const [divBased, setDivBased] = useState(position.isDivisionBased);
  const [err, setErr] = useState('');

  const doSave = async () => {
    if (!name.trim()) { setErr('Position must not be empty'); return; }
    try {
      await save.mutateAsync({ id: position.id, positionName: name.trim(), sort: sort.trim() === '' ? null : Number(sort), isDivisionBased: divBased });
      await alert({ title: 'Success', message: 'Saved successfully.', tone: 'success' });
      onClose();
    } catch (e) { notify.error(errMessage(e)); }
  };

  return (
    <div className="acc-overlay" style={{ zIndex: 1250 }} onMouseDown={(e) => { e.stopPropagation(); onClose(); }}>
      <div className="acc-dialog" onMouseDown={(e) => e.stopPropagation()}>
        <div className="acc-dialog-hdr"><span>{`${position.positionName || 'Position'} - Position`}</span><i className="ti ti-x acc-dialog-x" onClick={onClose} /></div>
        <div className="acc-dialog-body acc-compact">
          <div className="acc-field-h">
            <label className="acc-label acc-label-req">Position<span className="req">*</span></label>
            <div className="acc-fh-control">
              <input className="acc-input" autoFocus value={name} onChange={(e) => { setName(e.target.value); if (err) setErr(''); }}
                onKeyDown={(e) => { if (e.key === 'Enter') void doSave(); }} />
              {err && <div className="acc-err">{err}</div>}
            </div>
          </div>
          <div className="acc-field-h">
            <label className="acc-label">Sort</label>
            <div className="acc-fh-control"><input className="acc-input" type="number" value={sort} onChange={(e) => setSort(e.target.value)} /></div>
          </div>
          {/* LIMS renders the boolean as [checkbox] caption, indented to align under the
              Position/Sort input column (empty label spacer), not at the far-left label column. */}
          <div className="acc-field-h">
            <label className="acc-label" />
            <div className="acc-fh-control">
              <label className="acc-check-inline"><input type="checkbox" checked={divBased} onChange={(e) => setDivBased(e.target.checked)} /> Is Division Based</label>
            </div>
          </div>
        </div>
        <div className="acc-dialog-ftr">
          <button className="ca-btn ca-btn-solid" onClick={() => void doSave()} disabled={save.isPending}><span className="tb-i">💾</span> OK</button>
          <button className="ca-btn" onClick={onClose}><span className="tb-i tb-i-grey">↩︎</span> Cancel</button>
        </div>
      </div>
    </div>
  );
}
